import { RouteObject } from 'react-router';

import { OrderDetails } from './OrderDetails';
import { OrdersList } from './OrdersList';

export const ORDERS_ROUTES: RouteObject[] = [
    {
        index: true,
        Component: OrdersList,
    },
    {
        path: ':id',
        Component: OrderDetails,
    },
];
